import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import Text from 'components/shared/Text';
import { calendarIcon, clockIcon, todayBadge, upcomingBadge } from 'assets/newIcons';
import { CircularProgress } from '@material-ui/core';
import EmptyCard from '../EmptyCard';

const Card = ({ locationName, date, time, trainerName, photo, isToday }) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.card}>
        <div className={styles.subContainer1}>
          <img
            alt="trainer"
            className={`${styles.badge} ${isToday ? styles.today : styles.upcoming}`}
            src={isToday ? todayBadge : upcomingBadge}
          />

          <div className={styles.mainContentContainer}>
            <Text className={styles.locationName}>{locationName}</Text>

            <div className={styles.content}>
              <div className={styles.dateTimeContainer1}>
                <div className={styles.textContainer}>
                  <img alt="" className={styles.icon} src={calendarIcon} />
                  <p className={styles.date}>{date}</p>
                </div>
              </div>
              <div className={styles.dateTimeContainer2}>
                <div className={styles.textContainer}>
                  <img alt="" className={styles.icon} src={clockIcon} />
                  <p className={styles.time}>{time}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.subContainer2}>
          <img alt="" className={styles.photo} src={photo} />
          <Text className={styles.trainerName}>{trainerName}</Text>
        </div>
      </div>
    </div>
  );
};

const Sessions = ({ sessionData, sessionMessage, loadingSessions }) => {

  const [showAll, setShowAll] = useState(false);

  const sessionsToDisplay = showAll
    ? sessionData?.result?.sessions
    : sessionData?.result?.sessions.slice(0, 1);

  const handleToggleView = () => {
    setShowAll(!showAll);
  };

  return (
    <div className={styles.body}>
      <Text className={styles.mainHeading}>Upcoming Sessions</Text>
      <div className={`${styles.child}  ${loadingSessions ? styles.loading : null}`}>
        {loadingSessions ? (
          <CircularProgress size={50} style={{ color: '#FE5000', marginTop: '30px' }} />
        ) : sessionData !== null ? (
          <div className={styles.cardDiv}>
            {sessionsToDisplay?.map((data, index) => {
              return (
                <Card
                  locationName={data.clubName}
                  date={new Date(data.date).toLocaleDateString('en-US', {
                    weekday: 'long',
                    month: 'numeric',
                    day: 'numeric',
                  })}
                  time={new Date(`2000-01-01T${data?.startTime}`).toLocaleTimeString([], {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                  })}
                  trainerName={data?.trainerName}
                  photo={data?.trainerImage}
                  isToday={data?.isToday}
                />
              );
            })}
            {sessionData?.paginationResult?.totalCount > 1 && (
              <button className={styles.btn} onClick={handleToggleView}>
                {showAll ? 'View Less' : 'View More'}
              </button>
            )}
          </div>
        ) : (
          <EmptyCard message={sessionMessage} />
        )}
      </div>
    </div>
  );
};

export default Sessions;
